import { useState, useEffect, useRef } from "react";
import clsx from "clsx";

import styles from "./loading-screen.module.scss";

const LoadingScreen = () => {
  const [progress, setProgress] = useState<number>(0);
  const animationRef = useRef<number>(0);
  const startTimeRef = useRef<number>(0);
  const duration = 1500;

  useEffect(() => {
    const animate = (timestamp: number) => {
      if (!startTimeRef.current) startTimeRef.current = timestamp;

      const elapsed = timestamp - startTimeRef.current;
      const t = Math.min(elapsed / duration, 1);

      let progressValue;
      if (t < 0.5) {
        progressValue = 2 * t * t;
      } else {
        progressValue = -1 + (4 - 2 * t) * t;
      }

      setProgress(progressValue * 100);

      if (t < 1) {
        animationRef.current = requestAnimationFrame(animate);
      } else {
        setProgress(100);
      }
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, []);

  let opacity = 1;
  if (progress === 100) {
    opacity = 0;
  }

  return (
    <div className={styles.loading__screen} style={{ opacity: opacity }}>
      <div className={styles.screen__center}>
        <video
          src="/videos/loading.mp4"
          muted
          className={styles.screen__video}
          autoPlay
        />
        <p className={clsx(styles.screen__title, progress > 1 && styles.show)}>
          Создаем и развиваем
        </p>
      </div>

      <div className={styles.screen__footer}>
        <p className={styles.progress__percentage}>{Math.round(progress)}%</p>
        <div className={styles.screen__progress}>
          <div
            className={styles.progress}
            style={{
              width: `${progress}%`,
              transition: "width 50ms linear",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
